import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import( '@/views/flower/FlowerIndex.vue')
    },
    {
        path: '/login',
        component: () => import( '@/views/LoginView.vue')
    },
    {
        path: '/register',
        component: () => import('@/views/RegisterView.vue')
    },
    {
        path: '/plant/:id',
        component: () => import('@/views/flower/PlantView.vue')
    },
    {
        path: '/seedShop',
        component: () => import('@/views/flower/SeedShop.vue')
    },
    {
        path: '/addBasin',
        component: () => import('@/views/flower/AddBasin.vue')
    },
    {
        path: '/backpack',
        component: () => import('@/views/backpack/BackpackIndex.vue')
    },
    {
        path: '/backpack/plant/:id',
        component: () => import('@/views/backpack/PlantView.vue')
    },
    {
        path: '/rank',
        component: () => import('@/views/rank/RankView.vue')
    },
    {
        path: '/shop',
        component: () => import('@/views/shop/ShopIndex.vue')
    },
    {
        path: '/sign',
        component: () => import('@/views/sign/SignIndex.vue')
    },
    {
        path: '/magic',
        component: () => import('@/views/magic/MagicHouse.vue')
    },
    {
        path: '/magic/hc/:id',
        component: () => import('@/views/magic/FlowerCompound.vue')
    },
    {
        path: '/activity',
        name: 'activity',
        component: () => import('@/views/activity/ActivityIndex.vue')
    },
    {
        path: '/activity/gods',
        name: 'gods',
        component: () => import('@/views/activity/GodsIndex.vue')
    },
    {
        path: '/activity/gods/recipe',
        name: 'godsRecipe',
        component: () => import('@/views/activity/GodsRecipe.vue')
    },
    {
        path: '/activity/gods/shop',
        name: 'godsShop',
        component: () => import('@/views/activity/GodsShop.vue')
    },
    {
        path: '/greenhouse',
        name: 'greenhouse',
        component: () => import('@/views/Greenhouse.vue')
    },
    {
        path: '/activity/moon',
        name: 'moonIndex',
        component: () => import('@/views/activity/MoonIndex.vue')
    },
    {
        path: '/activity/moon/shop',
        name: 'moonShop',
        component: () => import('@/views/activity/MoonShop.vue')
    },
    {
        path: '/friend',
        name: 'friendList',
        component: () => import('@/views/friend/Friend.vue')
    },
    {
        path: '/friend/:id',
        name: 'friendGarden',
        component: () => import('@/views/friend/FriendGarden.vue')
    },
    {
        path: '/help',
        name: 'helpWiki',
        component: () => import('@/views/Help.vue')
    }
]

const router = new VueRouter({
    routes
})

export default router
